import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, } from 'react-bootstrap';
import Topbar from "../Components/Topbar/Topbar";
import { connect } from "react-redux";
import Sidebar from "../Components/Sidebar/Sidebar";
import LoadingSpinner from "../Components/LoadingSpinner";
import soujson from './class.json'
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import Select from 'react-select';
import moment from "moment/moment";
import { exportClassCreated, formatTime, getClassCreatedList } from "../Utils/utils";
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from "react-toastify";
import WarningModal from "../Components/Modals/WarningModal";
import ArchiveModal from "../Components/Modals/ArchiveModal";
import SuccessModal from "../Components/Modals/SuccessModal";
import config from "../config/config";
import axios from "axios";
import CustomSearch from "../Components/CustomSearch";
import { TimetoConvert } from "../Utils/TimeUtils";
import NotesModalNew from "../Components/Modals/NotesModalNew";

const ClassCreated = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [regualarClasses, setRegualarClasses] = useState([]);
  const [isShowRoll, setIsShowRoll] = useState(false);
  const [userId, setUserId] = useState('');
  const [archiveShow, setArchiveShow] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [isSuccessShowRoll, setIsSuccessShowRoll] = useState(false);
  const [noteuserId, setNoteUserId] = useState('');
  const [notesShow, setNotesShow] = useState(false);
  const [userNote, setUserNote] = useState('');
  const [noteNew, setNoteNew] = useState('');

  const handleFilterChange = (e) => { setFilterText(e.target.value); };



  const columns = [
    {
      id: 1,
      name: "Student Id",
      width: '110px',
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LD_SID}
        </div>
    },
    {
      id: 3,
      name: "Rank",
      cell: (row) =>
        <>
          <div className="row" style={{ fontSize: '12px' }}>
            <div className='cell-upper'>{row.RANK}</div>
          </div>
        </>,
      width: "80px",
      sortable: true,
    },
    {
      id: 4,
      name: "First Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.FIRSTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },
    {
      id: 5,
      name: "Last Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LASTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },

    {
      id: 7,
      name: "Home Email",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.HOME_EMAIL}
        </div>
      ),
      width: "250px"
    },

    // {
    //   id: 9,
    //   name: "Availability",
    //   cell: (row) =>
    //     <>
    //       <div className="row py-2">
    //         {row?.MON_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>MON - {formatTime(row?.MON_FROM, row?.MON_TO)}</div>}
    //         {row?.TUE_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>TUE - {formatTime(row.TUE_FROM, row.TUE_TO)} </div>}
    //         {row?.WED_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>WED - {formatTime(row.WED_FROM, row.WED_TO)} </div>}
    //         {row?.THUR_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>THUR - {formatTime(row.THUR_FROM, row.THUR_TO)} </div>}
    //         {row?.FRI_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>FRI - {formatTime(row.FRI_FROM, row.FRI_TO)} </div>}
    //         {row?.SAT_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SAT - {formatTime(row.SAT_FROM, row.SAT_TO)} </div>}
    //         {row?.SUN_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SUN - {formatTime(row.SUN_FROM, row.SUN_TO)} </div>}
    //       </div>
    //     </>,
    //   width: "170px"
    // },
    // {
    //   id: 8,
    //   name: "Availability in EST",
    //   cell: (row) =>
    //     <>
    //       <div className="row py-2">
    //         {row?.MON_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>MON - {TimetoConvert(row?.MON_FROM, row?.MON_TO, row?.TIMEZONE)}</div>}
    //         {row?.TUE_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>TUE - {TimetoConvert(row.TUE_FROM, row.TUE_TO, row.TIMEZONE)} </div>}
    //         {row?.WED_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>WED - {TimetoConvert(row.WED_FROM, row.WED_TO, row.TIMEZONE)} </div>}
    //         {row?.THUR_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>THUR - {TimetoConvert(row.THUR_FROM, row.THUR_TO, row.TIMEZONE)} </div>}
    //         {row?.FRI_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>FRI - {TimetoConvert(row.FRI_FROM, row.FRI_TO, row.TIMEZONE)} </div>}
    //         {row?.SAT_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SAT - {TimetoConvert(row.SAT_FROM, row.SAT_TO, row.TIMEZONE)} </div>}
    //         {row?.SUN_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SUN - {TimetoConvert(row.SUN_FROM, row.SUN_TO, row.TIMEZONE)} </div>}
    //       </div>
    //     </>,
    //   width: "170px"
    // },
    {
      id: 8,
      name: "Schedule in EST",
      cell: (row) =>
        <div className='' style={{ fontSize: '12px' }}>
          <div className="row pt-2 pb-3">
            {newTime(row?.selected_schedule).map((a) => (
              <>
                {a !== "" ?
                  <div className='cell-up' style={{ fontSize: '12px' }}>{a}</div>
                  : null}
              </>
            ))}
          </div>
        </div>,
      selector: (row) => row.PHONE,
      width: "160px"
    },
    {
      id: 10,
      name: "Instructor",
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row?.instructor_name}
        </div>,
      sortable: true,
      width: "110px"
    },
    {
      id: 13,
      name: "Course No.",
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.serialized_course_number}
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "110px"
    },
    {
      id: 9,
      name: "Timezone",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.TIMEZONE.includes('-') ? row.TIMEZONE.split('/')[0].trim() : row.TIMEZONE}
        </div>
      ),
      width: "140px"
    },

    {
      id: 11,
      name: "Start Date",
      sortable: true,
      cell: (row) => <div style={{ fontSize: '12px' }}
      >{moment(row.new_start_date).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 12,
      name: "End Date",
      sortable: true,
      cell: (row) => <div style={{ fontSize: '12px' }}
      >{row?.new_end_date ? moment(row?.new_end_date).format('MM/DD/YYYY') : (row.COURSETYPE == "STANDARD" || row.COURSETYPE == "TRADITIONAL")
        ? moment(row.new_start_date).add(10, 'weeks').format('MM/DD/YYYY')
        : moment(row.new_start_date).add(3, 'weeks').format('MM/DD/YYYY')
        }</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },

    {
      id: 14,
      name: "Course Type",
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.COURSETYPE}
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 15,
      name: "Uploaded On",
      selector: (row) => row.created_on,
      cell: (row) => <div className='' style={{ fontSize: '12px' }}
      >{moment(row.created_on).format('MM/DD/YYYY')}</div>, ignoreRowClick: true,
      allowOverflow: true,
      width: "110px"
    },
    {
      id: 16,
      name: "SOU sent on",
      selector: (row) => row.sou_sent_on,
      ignoreRowClick: true,
      cell: (row) => <div className='' style={{ fontSize: '12px' }}
      >{row?.sou_sent_on == null ? null : moment(row.sou_sent_on).format('MM/DD/YYYY')}</div>, ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 17,
      name: "Sou SIgned On",
      selector: (row) => row.sou_signed_on,
      cell: (row) => <div className='' style={{ fontSize: '12px' }}
      >{row?.sou_signed_on == null ? null : moment(row.sou_signed_on).format('MM/DD/YYYY')}</div>, ignoreRowClick: true,
      allowOverflow: true,
      width: "110px"
    },
    {
      id: 18,
      name: "Created / Exported on",
      cell: (row) => <div className='' style={{ fontSize: '12px' }}
      >{row?.updated_on == null ? null : moment(row.updated_on).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "120px"
    },
    // {
    //   id: 19,
    //   name: "Notes ",
    //   cell: (row) => <div className='' style={{ fontSize: '12px' }}
    //   >{row.notes}</div>,
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   width: "80px"
    // },
    {
      id: 20,
      width: "140px",
      name: "Action",
      cell: (row) => <div className='cell-link'
      ><>
          {/* <i className="text-warning fas fa-download mr-2" title="Download"
            onClick={() => {
            }}></i> */}
          {/* <i className="text-success far fa-edit mr-2" title="Edit"
            onClick={() => {
              // setNotesShow(true)
              // setNoteUserId(row?.LD_SID)
              // setUserNote(row?.notes)
            }}></i> */}
          <i className="text-danger fas fa-undo mr-2" title="Undo"
            onClick={() => {
              setUserId(row?.id)
              setIsShowRoll(true)
            }}></i>
          <i className="text-info fas fa-archive ml-3" title="Archive"
            onClick={() => {
              setArchiveShow(true)
              setNoteUserId(row?.LD_SID)
            }}></i>

          {row?.notes?.trim() ? <i className="text-warning far fa-sticky-note mr-2" title="Notes"
            onClick={() => {
              setNotesShow(true)
              setNoteUserId(row?.LD_SID)
              setUserNote(row?.notes)
            }}>
          </i>
            : ""}
        </></div>,
      // selector: (row) => <><i class="far fa-sticky-note"></i> <i class="fas fa-archive"></i></>,
    },
  ];

  const getAllClass = async () => {

    setIsLoading(true)
    var res = await getClassCreatedList()
    if (res.status == 200) {
      setRegualarClasses(res?.data)
      setIsLoading(false)
    }
  }
  useEffect(() => {
    getAllClass()
    // setPageCount(data.length / maxPageLimit)
  }, [reloadData])
  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));
  const LinearIndeterminate = () => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );
  };

  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    }
  ];

  const newTime = (time) => {
    let newMatch = time.split('&&&')
    let newArray = []
    newMatch.map((a) => {
      if (a !== "") {
        newArray.push(a)
      }
    })
    return newArray
  }
  const exportClass = async () => {
    if (regualarClasses.length > 0) {
      var res = await exportClassCreated()
      if (res.data.status == 200) {
        toast.success('Data exported successfully')
        window.location.href = res.data.data
      }
    } else {
      toast.error("No data to export")
    }
  }

  const onCloseRoll = () => {
    setIsSuccessShowRoll(false)
    getAllClass()
  }

  const removeStudent = async (id) => {
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/rollback-student', {
      id: id
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        setIsShowRoll(false)
        setIsSuccessShowRoll(true)
      })
      .catch((error) => {
        console.log(error)
      });
  }
  const onProceedRoll = async () => {
    removeStudent(userId)
  }

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar />
          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className={'new-card'} style={{ padding: "20px 15px 30px 15px" }}>
                  <div className='top-row'>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className='heading-text'>
                          Class Created/Data Exported for creation
                        </div>
                      </div>
                      <div className="col-lg-3">
                        {regualarClasses.length > 0 && (
                          <div className="main-btn2"
                            onClick={() => exportClass()}
                          >
                            Export CLass Created
                          </div>
                        )}
                      </div>
                      <div class="col-lg-3">
                        <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="row mb-4 mt-1">
                      <div className="col-md-12">
                        {regualarClasses.length > 0 ?
                          <div className="card m-overflow-h todo-card-list class-list" style={{ border: 'none' }}>
                            <div className="card-body m-p-0 data-tab filter-tab p-0">
                              <DataTableExtensions
                                columns={columns}
                                data={regualarClasses.filter((item) => Object.values(item).some((value) => String(value).toLowerCase().includes(filterText.toLowerCase().trim())))}
                                print={false}
                                export={false}
                                filter={false}
                              >

                                <DataTable
                                  pagination
                                  // paginationComponentOptions={paginationComponentOptions}
                                  // selectableRows
                                  conditionalRowStyles={conditionalRowStyles}
                                  // selectableRowsNoSelectAll={true}
                                  // onSelectedRowsChange={({ selectedRows }) => setSelectRowsArr(selectedRows)}
                                  persistTableHead
                                  progressComponent={<LinearIndeterminate />}
                                  paginationPerPage={10}
                                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                  highlightOnHover
                                  className="custom-table-border"
                                  customStyles={{
                                    headCells: {
                                      style: {
                                        backgroundColor: '#8A8A8A',
                                        color: '#ffffff',
                                      },
                                    },
                                  }}
                                />
                              </DataTableExtensions>


                            </div>
                          </div>
                          :
                          <div className="no-record">
                            There are no records to display.
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {isShowRoll == true ?
          <WarningModal
            isShow={isShowRoll}
            setIsShow={setIsShowRoll}
            onProceed={onProceedRoll}
          />
          : null}
        {archiveShow == true ?
          <ArchiveModal
            archiveShow={archiveShow}
            setArchiveShow={setArchiveShow}
            noteUserId={noteuserId}
            setReloadData={setReloadData}
          />
          : null}
        {isSuccessShowRoll == true ?
          <SuccessModal
            isSuccessShow={isSuccessShowRoll}
            setIsSuccessShow={setIsSuccessShowRoll}
            onClose={onCloseRoll}
          />
          : null}
        {notesShow == true ?
          <NotesModalNew
            notesShow={notesShow}
            setNotesShow={setNotesShow}
            noteUserId={noteuserId}
            userNote={userNote}
            setNoteNew={setNoteNew}
          />
          : null}
      </div>
    </>
  )
}
const mapStateToProps = state => ({
  // ...state
});
const mapDispatchToProps = dispatch => ({
  // rotateAction: (payload) => dispatch(userAction(payload))
});
export default connect(mapStateToProps, mapDispatchToProps)(ClassCreated);